import {
  gql
} from "@apollo/client";
import { CHARGER_ASSET_DETAILS_FRAGMENT } from "gql/fragments";

export const SINGLE_CHARGER = gql`
  ${CHARGER_ASSET_DETAILS_FRAGMENT}
  query Chargers($chargers_n: Int, $where: InputSalesforceChargerOperators) {
    chargers(n: $chargers_n, where: $where, ) @connection(key: "singleCharger") {
      edges {
        cursor
        node {
          salesforce_details: salesforce_details {
            ...ChargerAssetDetails
          }
          assetDetails: salesforce_details {
            ...ChargerAssetDetails
          }
          details: salesforce_details {
            ...ChargerAssetDetails
          }
          serial
          total_energy
          vpn_status {
            connections {
              allowed_ips
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`;

export const SINGLE_CHARGER_STATUS_MESSAGES = gql`
  query Charger_status_messages($n: Int, $after: String, $chargers_where: InputSalesforceChargerOperators, $status_messages_where: InputChargerStatusEntryOperators) {
    charger_monitors(where: $chargers_where) @connection(key: "singleChargerStatusMessages") {
      __typename
      charger_status_messages(n: $n, after: $after, where: $status_messages_where) {
        edges {
          cursor
          node {
            errorCode
            vendorErrorCode
            receiveTimestamp
            serial
            info
            status
          } 
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
      }
    }
  }
`;

export const CHARGER_UPTIME = gql`
  query Single_charger_uptime($n: Int, $where: InputSalesforceChargerOperators) {
    chargers(n: $n, where: $where) @connection(key: "chargerUptime") {
      edges {
        node {
          uptime {
            calculation_name
            calculation_type
            calculation_update_interval
            calculation_update_timestamp
            calculation_value
          }
        }
      }
    }
  }
`;

export const CLEAR_CACHE = gql`
  mutation Clear_cache($serial: String) {
    charger_ocpp_mutation {
      clear_cache(serial: $serial) {
        payload {
          status
        }
      }
    }
  }
`;

export const GET_CONFIGURATION = gql`
  query Get_charger_config($n: Int, $where: InputSalesforceChargerOperators) {
    chargers(n: $n, where: $where) @connection(key: "chargerConfig") {
      edges {
        node {
          serial
          charger_configuration {
            change_status
            changed_timestamp
            charger_value
            config_key
            readonly
            set_value
          }
        }
      }
    }
  }
`;

/** Triggers OCPP GetConfiguration on the charger; backend persists result. Call this before refetching GET_CONFIGURATION to show fresh config. */
export const GET_CONFIGURATION_OCPP = gql`
  query Get_configuration_ocpp($serial: String!) {
    charger_ocpp_query {
      get_configuration(serial: $serial, payload: {}) {
        response_type
        payload
      }
    }
  }
`;

export const CHANGE_CONFIGURATION = gql`
  mutation Change_configuration($payload: InputChangeConfigurationRequestPayload!, $serial: String) {
    charger_ocpp_mutation {
      change_configuration(payload: $payload, serial: $serial) {
        payload {
          status
        }
      }
    }
  }
`;

export const GET_DIAGNOSTICS = gql`
  query Get_diagnostics($payload: InputGetDiagnosticsRequestPayload, $serial: String) {
    charger_ocpp_query {
      get_diagnostics(payload: $payload, serial: $serial) {
        fileName
      }
    }
  }
`;

export const RESET = gql`
  mutation Reset($payload: InputResetRequestPayload, $serial: String) {
    charger_ocpp_mutation {
      reset(payload: $payload, serial: $serial) {
        payload {
          status
        }
      }
    }
  }
`;

export const UPDATE_FIRMWARE = gql`
  mutation Update_firmware($payload: InputUpdateFirmwareRequestPayload, $serial: String) {
    charger_ocpp_mutation {
      update_firmware(payload: $payload, serial: $serial) {
        payload {
          status
        }
      }
    }
  }
`;

export const GET_TEST_REPORT_PDF = gql`
  query Pdf_by_serial_gitlab($serial: String) {
    pdf_by_serial_gitlab(serial: $serial) {
      base64
    }
  }
`;

export const NOTIFY_AMPOL_INSTALL = gql`
  mutation Notify_ampol_install($serial: String) {
    notify_ampol_install(serial: $serial) {
      id
      message
      status
    }
  }
`;

export const UNINSTALL_CHARGER = gql`
  mutation Uninstall_charger($serial: String) {
    uninstall_charger(serial: $serial) {
      edges {
        node {
          serial
          salesforce_details {
            installation_ref
            owner_id
          }
        }
      }
      result {
        status
      }
    }
  }
`;
